import { NgModule } from '@angular/core';

import { EffectsModule, provideEffects } from '@ngrx/effects';
import { provideState, StoreModule } from '@ngrx/store';

import { IntelligenceSettingsEffects } from './intelligence-settings-effects.service';
import {
  IntelligenceSettingsNamespace,
  IntelligenceSettingsReducer,
} from './intelligence-settings.store';

@NgModule({
  imports: [
    StoreModule.forFeature(IntelligenceSettingsNamespace, IntelligenceSettingsReducer),
    EffectsModule.forFeature([IntelligenceSettingsEffects]),
  ],
})
export class IntelligenceSettingsDataModule {}

export const provideIntelligenceSettingsState = provideState(
  IntelligenceSettingsNamespace,
  IntelligenceSettingsReducer,
);
export const provideIntelligenceSettingsEffects = provideEffects([IntelligenceSettingsEffects]);
